export default [
    {
        path: '/arp/records',
        name: 'arp-records',
        component: () => import('./views/ArpRecordIndex'),
        meta: {
            title: 'Registros ARP',
            icon: 'mdi-shield-lock-outline',
            breadcrumbs: [
                { text: 'Auditoria', disabled: true, href: '/' },
                { text: 'Registros ARP', disabled: true, href: '/' },
            ],
        }
    },
]
